import dayjs from 'dayjs';

export const QUICK_KEY = {
  today: 'today',
  yesterday: 'yesterday',
  currentWeek: 'currentWeek',
  currentMonth: 'currentMonth',
  currentYear: 'currentYear',
  prevWeek: 'prevWeek',
  prevMonth: 'prevMonth',
  custom: 'custom',
  fiscalYear: 'fiscalYear',
};

export const QUICK_TEXT = {
  [QUICK_KEY.custom]: '自定义',
  [QUICK_KEY.today]: '今日',
  [QUICK_KEY.yesterday]: '昨日',
  [QUICK_KEY.currentWeek]: '本周',
  [QUICK_KEY.currentMonth]: '本月',
  [QUICK_KEY.currentYear]: '全年',
  [QUICK_KEY.prevWeek]: '上周',
  [QUICK_KEY.prevMonth]: '上月',
  [QUICK_KEY.fiscalYear]: '财年',
};

export const formatString = 'YYYY-MM-DD';

export function today() {
  const start = dayjs().format(formatString);
  // const end = dayjs().add(1, 'day').format(formatString);

  return [start, start];
}

export function yesterday() {
  const start = dayjs().subtract(1, 'day').format(formatString);
  // const end = dayjs().format(formatString);
  const end = dayjs().subtract(1, 'day').format(formatString);
  return [start, end];
}

export function currentWeek() {
  const start = dayjs()
    .subtract(dayjs().day() ? dayjs().day() - 1 : 6, 'day')
    .format(formatString);
  const end = dayjs().format(formatString);

  return [start, end];
}

export function currentMonth() {
  const start = dayjs().startOf('month').format(formatString);
  const end = dayjs().format(formatString);
  return [start, end];
}

export function currentYear() {
  const start = dayjs().startOf('year').format(formatString);
  const end = dayjs().format(formatString);
  return [start, end];
}

export function prevWeek() {
  const start = dayjs().add(-1, 'week').startOf('week').add(1, 'day').format(formatString);
  const end = dayjs().add(-1, 'week').endOf('week').add(1, 'day').format(formatString);
  return [start, end];
}

export function prevMonth() {
  const start = dayjs().add(-1, 'month').startOf('month').format(formatString);
  const end = dayjs().add(-1, 'month').endOf('month').format(formatString);
  return [start, end];
}

export function fiscalYear() {
  const now = dayjs();
  const currentMonth = now.month() + 1; // dayjs月份从0开始，所以+1获取实际月份
  
  let startYear, endYear;
  
  if (currentMonth >= 10) {
    // 7月及之后（包含7月1日），财年从今10月1日到明年9月30日
    startYear = now.year();
    endYear = now.year() + 1;
  } else {
    // 10月之前（不包含10月1日），财年从去年10月1日到今年9月30日
    startYear = now.year() - 1;
    endYear = now.year();
  }
  
  const start = dayjs(`${startYear}-10-01`).format(formatString);
  const end = dayjs(`${endYear}-09-30`).format(formatString);
  
  return [start, end];
}

export function getDateRangeByType(type, formData = {}) {
  if (type === QUICK_KEY.today) {
    return today();
  } else if (type === QUICK_KEY.yesterday) {
    return yesterday();
  } else if (type === QUICK_KEY.currentWeek) {
    return currentWeek();
  } else if (type === QUICK_KEY.currentMonth) {
    return currentMonth();
  } else if (type === QUICK_KEY.currentYear) {
    return currentYear();
  } else if (type === QUICK_KEY.prevWeek) {
    return prevWeek();
  } else if (type === QUICK_KEY.prevMonth) {
    return prevMonth();
  } else if (type === QUICK_KEY.custom) {
    const customData = localStorage.getItem('customData');
    if (customData) {
      return customData.split(',');
    } else if (formData?.dateRange) {
      return formData.dateRange;
    } else {
      return [];
    }
  } else if (type === QUICK_KEY.fiscalYear) {
    return fiscalYear();
  } else {
    return formData?.dateRange ?? [];
  }
}
